import React from "react";
// import Link
import { Link } from "react-router-dom";
// import img

import img4 from "../../../assets/img/offer/hajj.png";
import img5 from "../../../assets/img/offer/hajj.jpg";

const SpecialOffer = () => {
  return (
    <>
      <section id="offer_area" className="section_padding_top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="offer_area_box d-none-phone img_animation">
                <img src={img5} alt="img" />
                <div className="offer_area_content">
                  <h2>Hajj Packages</h2>
                  {/* <p>
                    Invidunt ut labore et dolore magna aliquyam erat, sed diam
                    voluptua. At vero eos et accusam et justo duo dolores et ea
                    rebum. Stet clita kasd dolor sit amet. Lorem ipsum dolor sit
                    amet.
                  </p> */}
                  <Link to="/hajj/package-1" className="btn btn_theme btn_sm">
                    Get Details
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="offer_area_box d-none-phone img_animation">
                <img src={img4} alt="img" />
                <div className="offer_area_content">
                  <h2>Umrah Packages</h2>
                  {/* <p>
                    Invidunt ut labore et dolore magna aliquyam erat, sed diam
                    voluptua. At vero eos et accusam et justo duo dolores et ea
                    rebum. Stet clita kasd dolor sit amet. Lorem ipsum dolor sit
                    amet.
                  </p> */}
                  <Link to="/package1" className="btn btn_theme btn_sm">
                    Get Details
                  </Link>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="offer_area_box img_animation">
                <img src={img3} alt="img" />
                <div className="offer_area_content">
                  <h2>Ziyarat Packages</h2>
                  {/* <p>
                    Invidunt ut labore et dolore magna aliquyam erat, sed diam
                    voluptua. At vero eos et.
                  </p> *
                  <Link to="#!" className="btn btn_theme btn_sm">
                    Get Details
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default SpecialOffer;
